import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'
import PrivateRoute from 'components/routes/Private'
import NoGlobalRolesRoute from 'components/routes/NoGlobalRoles'

import {
  GLOBAL_ROLES,
  PRODUCT_ROLES,
  PROJECT_ROLES,
  ROUTE_ROLES,
} from 'containers/Role/constants'

import Dashboard from 'containers/Report/Dashboard'
import Greenlight from 'containers/Report/Greenlight'
import Nvqual from 'containers/Report/Nvqual'
import WeeklyStatus from 'containers/Report/WeeklyStatus'

const ReportRoute = props => {
  return (
    <Switch>
      <NoGlobalRolesRoute exact path='/report/dashboard' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={Dashboard} />
      <NoGlobalRolesRoute exact path='/report/greenlight' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={Greenlight} />
      <NoGlobalRolesRoute exact path='/report/nvqual' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={Nvqual} />
      <NoGlobalRolesRoute exact path='/report/weeklystatus' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={WeeklyStatus} />
    </Switch>
  )
}

export default ReportRoute
